module.exports = __webpack_public_path__ + "img/photo-0090.8334aefc.jpg";